<template>
  <div class="about-page">
    <div class="top-banner">
      <img :src="baseUrl + '/banner3.png'" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="label">六年沉淀</div>
        <div class="label ">让器械合规与创新同行</div>
      </div>
    </div>

    <div class="about-main">
      <img :src="baseUrl + '/about1.png'" alt="Banner" class="about-image" />

      <div class="sub-title clear">发展历程</div>
      
      <img :src="baseUrl + '/about3.png'" alt="Banner" class="about-image" />

      <div class="sub-title">服务优势</div>

      <img :src="baseUrl + '/about2.png'" alt="Banner" class="about-image" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { baseUrl } from '@/utils';
</script>

<style lang="less" scoped>
.about-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;

  .banner-info {
    position: absolute;
    right: 30px;
    top: 0;
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .label {
      font-family: YouSheBiaoTiHei;
      font-size: 80px;
      line-height: 110px;
      color: #101010;
    }
  }
  .top-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .about-main {
    width: 1400px;
    margin: 0 auto;
    padding: 50px 0 30px;
    .about-image {
      width: 1350px;
   
    }
    .sub-title {
      width: 560px;
      margin: 120px 0 40px;
      border-bottom: 8px solid #254AB9;
      font-family: YouSheBiaoTiHei;
      font-size: 50px;
      color: #101010;
      &.clear {
        margin-bottom: 0;
      }
    }
  }
}

// 小分比率适配
@media screen and (max-width: 1560px) {
  .about-page {
    min-width: 1200px;
    .top-banner {
      width: 100%;
      height: 520px;
      .banner-info {
        height: 520px;
      }
      .label {
        margin: 22px 0 30px;
        font-size: 70px;
        line-height: 84px;
      }
    }

    .about-main {
      width: 1200px;
      .about-image {
        width: 1150px;
      }
      .sub-title {
        width: 480px;
        border-bottom-width: 6px;
      }
    }
  }
}

// 小分比率适配
@media screen and (max-width: 1400px) {
  .about-page {
    min-width: 1080px;
    .top-banner {
      width: 100%;
      height: 500px;
      .banner-info {
        height: 500px;
      }
      .label {
        margin: 15px 0 20px;
        font-size: 60px;
        line-height: 72px;
      }
    }

    .about-main {
      width: 1080px;
      .about-image {
        width: 1020px;
      }
      .sub-title {
        width: 420px;
        border-bottom-width: 5px;
      }
    }
  }
}
</style>